import { withInstall } from '../../../../utils/with-install'
import MapboxVectorTileLayer from './MapboxVectorTileLayer.vue'

export const ElAmapLayerMapboxVectorTile = withInstall(MapboxVectorTileLayer)
export default ElAmapLayerMapboxVectorTile
